import { dayjsUTC } from "@/helpers/dateHelper"
import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { WarrantsFilesProcessed } from "@/models/admin/warrantsFilesProcessed/warrantsFilesProcessed"
import { IWarrantsFilesProcessed } from "@/models/admin/warrantsFilesProcessed/warrantsFilesProcessed.types"
import {
  WarrantsFilesDcaType,
  WarrantsFilesType,
} from "@/models/admin/warrantsFilesAccount/warrantsFilesAccount.types"

/**
 * A single `warrants_files_processed` row as returned by Hasura. Mirrors the
 * generated `Financials_Warrants_Files_Processed` row; kept as a narrow type
 * so the parser only depends on the columns it actually reads.
 */
export type WarrantsFilesProcessedRaw = {
  id: number
  dca_type: string
  file_type: string
  folder: string
  file_name: string
  job_id?: number | null
  created_at: string
}

export const WarrantsFilesProcessedParser: IParser<
  IWarrantsFilesProcessed,
  WarrantsFilesProcessedRaw
> = {
  toDomain(data) {
    try {
      // Hasura `timestamp` columns are naive UTC, so parse them as UTC and
      // convert to local time for display.
      return new WarrantsFilesProcessed(
        data.id,
        data.dca_type as WarrantsFilesDcaType,
        data.file_type as WarrantsFilesType,
        data.folder,
        data.file_name,
        data.job_id ?? null,
        dayjsUTC(data.created_at),
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
